var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropzoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 16.2403L6.07227 13.3125L6.8742 12.5106L8.43758 14.0741V9.56252H3.93758L5.50095 11.1145L4.68758 11.9278L1.75977 9.00002L4.67595 6.08364L5.47789 6.88558L3.92595 8.43752H8.43758V3.92589L6.8742 5.48946L6.07227 4.68752L9.00008 1.7597L11.9279 4.68752L11.126 5.48946L9.56258 3.92589V8.43752H14.0626L12.4992 6.88558L13.3126 6.0722L16.2404 9.00002L13.3126 11.9278L12.5106 11.1259L14.0742 9.56252H9.56258V14.0625L11.1145 12.4991L11.9279 13.3125L9.00008 16.2403Z",
    fill: "#D9DBDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzoneIcon);
export default __webpack_public_path__ + "static/media/dropzone-icon.026822bd50b0992ff96ef2ca8f78f8d3.svg";
export { ForwardRef as ReactComponent };